/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'

/**
 *
 * @export
 * @interface EnvelopedDocumentDestroyAdmin
 */
export interface EnvelopedDocumentDestroyAdmin {
  /**
   *
   * @type {any}
   * @memberof EnvelopedDocumentDestroyAdmin
   */
  body: any | null
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedDocumentDestroyAdmin
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedDocumentDestroyAdmin interface.
 */
export function instanceOfEnvelopedDocumentDestroyAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedDocumentDestroyAdminFromJSON(json: any): EnvelopedDocumentDestroyAdmin {
  return EnvelopedDocumentDestroyAdminFromJSONTyped(json, false)
}

export function EnvelopedDocumentDestroyAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedDocumentDestroyAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: json['body'],
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedDocumentDestroyAdminToJSON(
  value?: EnvelopedDocumentDestroyAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: value.body,
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
